<script>
   /**************************************************************/
   /* Svelte component for selection of a component              */
   /**************************************************************/

   import { Container as ControlElementContainer, Range } from '.';

   export let maxNComp = 1;
   export let value = 1;
   export let label = '# PCs';
</script>

<ControlElementContainer {label}>
<Range id="ncomp" bind:value min={1} max={maxNComp} step={1} decNum={0}/>
</ControlElementContainer>

